<template>
    <div class="prompt">
        <primevue-button class="prompt-button" text @click="sendMessage(props.prompt.prompt)">
            <div class="prompt-text">{{ props.prompt.prompt }}</div>
        </primevue-button>
    </div>
</template>

<script lang="ts" setup>
import PrimevueButton from 'primevue/button';
import { IPrompt } from '@/interfaces/deltaGpt/IPrompt.ts';

const props = defineProps<{ prompt: IPrompt }>();

const emit = defineEmits<{ 'send-message': [string] }>();

function sendMessage (message: string): void {
    emit('send-message', message);
}
</script>

<style lang="scss" scoped>
.prompt {
    background-color: var(--neutral0);
    border-radius: var(--borderRadiusOuter);
    // box-shadow: 0px 1px 5px var(--neutral300);

    .prompt-button {
        align-items: flex-start;
        color: var(--primaryFont);
        display: flex;
        font-size: var(--smallFontSize);
        background-color: transparent;
        gap: 0px;
        height: 100%;
        justify-content: space-between;
        padding: 0;
        text-align: left;
        font-style: italic;
        width: 100%;
        &:hover {
            background-color: var(--neutral300);
        }
        .prompt-text {
            padding: var(--largeSpacing);
        }
    }
}
</style>
